<h2 mat-dialog-title>
  Udenlandsk valuta
  <mat-divider></mat-divider>
</h2>
<mat-dialog-content class="pb-2">
  <div fxLayout="column">
    <span>Angiv hvilken et felt der skal beregnes når brugeren opretter transaktioner</span>
    <form [formGroup]="form" fxFlex="100" fxLayout="column" fxLayoutGap="10px">
      <div fxFlex="45" fxLayout="column">
        <mat-radio-group formControlName="calc_field" fxLayout="column">
          <mat-radio-button [value]="'exchange_rate'">Beregn valutakurs</mat-radio-button>
          <mat-radio-button [value]="'amount'">Beregn lokalvaluta</mat-radio-button>
        </mat-radio-group>
      </div>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Luk</button>
  <button mat-flat-button [disabled]="form.invalid" (click)="doSave()">Gem</button>
</mat-dialog-actions>
